export const getCheckmateUtilityUrl = (path, isAuIp = false) => {
  const base = isAuIp ? 'https://www.checkmate.tech/au' : 'https://www.checkmate.tech';
  return `${base}/utility/${path.replace(/^\//, '')}`;
};
